import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import './TopScorersPage.css';

const LEAGUE_TABS = [
  { id: 'epl',    label: 'Premier League' },
  { id: 'laliga', label: 'La Liga' },
  { id: 'serie',  label: 'Serie A' },
  { id: 'bundes', label: 'Bundesliga' },
  { id: 'ligue1', label: 'Ligue 1' },
];

export default function TopScorersPage() {
  const [activeLeague, setActiveLeague] = useState('epl');
  const [scorers, setScorers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiService.getTopScorers(activeLeague).then(res => {
      setScorers(res.scorers || []);
      setLoading(false);
    });
  }, [activeLeague]);

  const maxGoals = scorers[0]?.goals || 1;

  return (
    <div className="scorers-page">
      <div className="scorers-page-header">
        <h1>Top Scorers</h1>
        <p className="page-sub">Leading goalscorers across Europe's top leagues</p>
      </div>

      <div className="league-tabs">
        {LEAGUE_TABS.map(t => (
          <button
            key={t.id}
            className={`league-tab ${activeLeague === t.id ? 'active' : ''}`}
            onClick={() => setActiveLeague(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading && <div className="loading-state">Loading…</div>}

      {!loading && scorers.length > 0 && (
        <div className="scorers-grid">
          {scorers.map(s => (
            <div key={s.rank} className={`scorer-card rank-${s.rank}`}>
              <div className="scorer-rank">#{s.rank}</div>
              <div className="scorer-photo-wrap">
                <img
                  src={s.photo}
                  alt={s.name}
                  className="scorer-photo"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <div className="scorer-info">
                <div className="scorer-name">{s.name}</div>
                <div className="scorer-team">
                  <img src={s.team.logo} alt="" />
                  <span>{s.team.name}</span>
                </div>
                <div className="scorer-goals-bar">
                  <div
                    className="scorer-goals-fill"
                    style={{ width: `${(s.goals / maxGoals) * 100}%` }}
                  ></div>
                </div>
                <div className="scorer-stats">
                  <div className="scorer-stat goals">
                    <div className="stat-num">{s.goals}</div>
                    <div className="stat-label">Goals</div>
                  </div>
                  <div className="scorer-stat">
                    <div className="stat-num">{s.assists}</div>
                    <div className="stat-label">Assists</div>
                  </div>
                  <div className="scorer-stat">
                    <div className="stat-num">{s.matches}</div>
                    <div className="stat-label">Matches</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && scorers.length === 0 && (
        <div className="loading-state">No data available for this league.</div>
      )}
    </div>
  );
}
